import { useEffect, useState } from "react";
import AdminPageLayout from "../components/AdminPageLayout";
import { fetchMediaImageUses, createMediaImageUse, deleteMediaImageUse } from "./adminMediaImageService";
import { useToast } from "../../common/toast/ToastContext";

const AdminMediaImageUsesPage = () => {
  const { showToast } = useToast();
  const [uses, setUses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newName, setNewName] = useState("");
  const [saving, setSaving] = useState(false);
  const [rowErrors, setRowErrors] = useState({});

  const load = async () => {
    setLoading(true);
    const res = await fetchMediaImageUses();
    if (res.status === 200) setUses(res.data || []);
    else showToast("Failed to load image uses", "error");
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleAdd = async () => {
    const name = newName.trim().toUpperCase();
    if (!name) return;
    setSaving(true);
    const res = await createMediaImageUse(name);
    if (res.status === 200 || res.status === 201) {
      showToast("Image use created", "success");
      setNewName("");
      await load();
    } else if (res.status === 409) {
      showToast("Image use already exists", "error");
    } else {
      showToast(res.message || "Create failed", "error");
    }
    setSaving(false);
  };

  const handleDelete = async (use) => {
    setRowErrors((prev) => ({ ...prev, [use]: "" }));
    const res = await deleteMediaImageUse(use);
    if (res.status === 200 || res.status === 204) {
      showToast("Image use deleted", "success");
      await load();
    } else if (res.status === 400) {
      setRowErrors((prev) => ({ ...prev, [use]: "Cannot delete — image use is in use" }));
    } else if (res.status === 404) {
      showToast("Image use not found", "error");
    } else {
      showToast(res.message || "Delete failed", "error");
    }
  };

  return (
    <AdminPageLayout
      title="Media Image Uses"
      subtitle="Manage the image use categories available for media images."
    >
      <div style={{ display: "flex", gap: 8, marginBottom: "1.5rem", maxWidth: 400 }}>
        <input
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleAdd()}
          placeholder="New image use name"
          style={{ flex: 1, padding: "0.45rem 0.75rem", border: "1px solid #d1d5db", borderRadius: 6, fontSize: "0.9rem" }}
        />
        <button className="adm-btn adm-btn-primary" onClick={handleAdd} disabled={saving || !newName.trim()}>
          {saving ? "Adding…" : "Add"}
        </button>
      </div>

      {loading ? (
        <p className="adm-loading">Loading…</p>
      ) : uses.length === 0 ? (
        <p className="adm-empty">No image uses yet.</p>
      ) : (
        <div className="ac-table-wrap">
          <table className="ac-table">
            <thead>
              <tr>
                <th>Image Use Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {uses.map((use) => (
                <tr key={use}>
                  <td>
                    <strong>{use}</strong>
                    {rowErrors[use] && (
                      <span style={{ marginLeft: 10, color: "#b91c1c", fontSize: "0.82rem" }}>
                        {rowErrors[use]}
                      </span>
                    )}
                  </td>
                  <td>
                    <button className="adm-btn adm-btn-danger adm-btn-sm" onClick={() => handleDelete(use)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminPageLayout>
  );
};

export default AdminMediaImageUsesPage;
